import { useState } from 'react';
import useModal from 'src/components/Modals/hooks/useModal';
import FeatureAnnouncementBaseModal from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncementBaseModal';
import FeatureAnnouncementBaseLayout from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncementBaseLayout';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { FeatureAnnouncementModalPageConfig } from 'src/components/Modals/FeatureAnnouncementModal/types';
import {
	FEATURE_ANNOUNCEMENT_PREVIEW_IMAGES_PATH,
	FEATURE_ANNOUNCEMENT_S3_BUCKET_PATH,
} from 'src/components/Modals/FeatureAnnouncementModal/consts';

const S3_BUCKET_PATH = `${FEATURE_ANNOUNCEMENT_S3_BUCKET_PATH}/auto-signing`;
const PREVIEW_IMAGE_PATH = `${FEATURE_ANNOUNCEMENT_PREVIEW_IMAGES_PATH}/auto-signing`;

const AUTO_SIGNING_PAGES_CONFIG: FeatureAnnouncementModalPageConfig[] = [
	{
		title: 'Auto-Signing: Seamless Trading, No More Wallet Prompts',
		description:
			'Experience faster trading on Velocity with Auto-Signing — no more signing every trading transaction manually from your wallet.',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/first-page-desktop.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/first-page-desktop.webp`,
		},
		mobileMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/first-page-mobile.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/first-page-mobile.webp`,
		},
	},
	{
		title: 'Enable Auto-Signing with Few Simple Steps',
		description: (
			<>
				<p>1. Click [Enable Trading] on Trade page</p>
				<p>
					2. Approve two wallet transactions to establish the connection and
					activate Auto-Signing. Once enabled, you&apos;re ready to trade
					instantly!
				</p>
			</>
		),
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/second-page-desktop.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/second-page-desktop.webp`,
		},
		mobileMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/second-page-mobile.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/second-page-mobile.webp`,
		},
	},
];

export const FeatureAnnouncementAutoSigningModal = () => {
	const { hide } = useModal();
	const isMobileScreenSize = useIsMobileScreenSize();

	const [currentStep, setCurrentStep] = useState(0);

	const currentPageConfig = AUTO_SIGNING_PAGES_CONFIG[currentStep];

	return (
		<FeatureAnnouncementBaseModal
			announcementName="privyAutoSigning"
			title="Auto-Signing"
			onClose={hide}
			currentStep={currentStep}
			setCurrentStep={setCurrentStep}
			showBackButton={currentStep > 0}
			pagesConfig={AUTO_SIGNING_PAGES_CONFIG}
		>
			<FeatureAnnouncementBaseLayout
				title={currentPageConfig.title}
				description={currentPageConfig.description}
				media={{
					...(isMobileScreenSize
						? currentPageConfig.mobileMedia
						: currentPageConfig.desktopMedia),
				}}
				mediaLoadingHeight={
					isMobileScreenSize ? 'calc((100vw - 32px) * 0.864)' : 338.2
				}
				step={currentStep}
				totalSteps={AUTO_SIGNING_PAGES_CONFIG.length}
			/>
		</FeatureAnnouncementBaseModal>
	);
};
